import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  clubForId,
  organisationTitleOf,
  organisationWordOf,
} from 'utils/clubFeatures';

// The club on screen's word for itself (utils/clubFeatures.js): "club" in a
// sentence and "Club" in a title, or "school" and "School" for a school
// (Doug, 2026-10-27, school words pass 2: "Add School Record", "the school
// record").
//
// The club is found as useGroupLabels finds it: the one passed in, or the one
// in the web address (the meet and results pages carry a club id), and
// otherwise the selected club. It is read from the club list already in
// memory, so no request is made.
const useOrganisationWords = (clubId) => {
  const { clubId: routeClubId } = useParams();
  const club = useSelector((state) => clubForId(state.user, clubId || routeClubId));
  return { word: organisationWordOf(club), title: organisationTitleOf(club) };
};

export default useOrganisationWords;
